import React from "react";

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t border-gray-200">
      {/* Main Footer Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2 sm:py-3">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-4">
          
          {/* Címünk */}
          <div className="pb-2 border-b border-gray-200 sm:border-0 text-center">
            <h3 className="footer-title-hover font-semibold text-gray-900 mb-2 text-base">Címünk</h3>
            <p className="text-sm text-gray-600">Kisvárda, Attila u. 61, 4600</p>
          </div>

          {/* Nyitvatartás */}
          <div className="pb-2 border-b border-gray-200 sm:border-0 text-center">
            <h3 className="footer-title-hover font-semibold text-gray-900 mb-2 text-base">Nyitvatartás</h3>
            <p className="text-sm text-gray-600">Hétfő - Péntek: 9:00-17:00</p>
            <p className="text-sm text-gray-600">Szombat: 8:00-13:00</p>
          </div>

          {/* Kapcsolat */}
          <div className="text-center">
            <h3 className="footer-title-hover font-semibold text-gray-900 mb-2 text-base">Kapcsolat</h3>
            <div className="space-y-1 text-sm text-gray-600">
              <a href="tel:06704179210" className="block hover:text-gray-900 transition-colors">
                <span className="inline-block mr-2">📞</span>
                Telefonszám: 06 (70) 417 9210
              </a>
              <a href="mailto:xlbutorbolt@gmail.com" className="block hover:text-gray-900 transition-colors">
                <span className="inline-block mr-2">✉️</span>
                xlbutorbolt@gmail.com
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom Footer */}
      <div className="border-t border-gray-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-2">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-2 md:space-y-0 gap-2">
            
            {/* Copyright */}
            <div className="text-xs text-gray-500 text-center md:text-left">
              © 2025 XL bútor
            </div>

            {/* Legal Links */}
            <div className="flex flex-wrap justify-center gap-3 sm:gap-4 text-xs text-gray-500">
              <a href="/impresszum" className="hover:text-gray-700 transition-colors">Impresszum</a>
              <a href="/aszf" className="hover:text-gray-700 transition-colors">ÁSZF</a>
              <a href="/adatvedelmi-nyilatkozat" className="hover:text-gray-700 transition-colors">Adatvédelmi nyilatkozat</a>
            </div>

          </div>
        </div>
      </div>
    </footer>
  );
}